// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"133e6361","84":"c9409e6e","439":"6f9b44a3","453":"64aababc","493":"590e1b43","530":"ab195527","614":"da0410e9","886":"a5a5f760","973":"e1c090c5"}[chunkId] + ".chunk.js";
};